import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-limitexceeded-msg-modal",
  templateUrl: "./limitexceeded-msg-modal.component.html",
  styles: [],
})
export class LimitexceededMsgModalComponent implements OnInit {
  @Input() confirmValues: any;

  constructor(public dialogRef: NgbActiveModal, public router: Router) {}

  ngOnInit(): void {}
  confirm() {
    this.dialogRef.close({ success: true });
  }
}
